import { NgFor } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TrackByFunction } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

export interface ChipSetConfig {
  label: string;
  value: string;
  disabled?: boolean;
}

@Component({
  selector: "tpm-chip-set",
  templateUrl: "chip-set.component.html",
  styleUrls: ["chip-set.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgFor, TranslateModule]
})
export class ChipSetComponent {
  @Output() readonly selected = new EventEmitter<Array<string>>();

  @Input() nowrap: boolean = false;
  @Input() huge: boolean = false;
  @Input() chips: Array<ChipSetConfig> = [];
  @Input()
  set active(values: Array<string> | undefined) {
    this.selection.clear();

    if (values) {
      values.forEach((value) => {
        this.selection.add(value);
      });
    }
  }
  get active(): Array<string> {
    return Array.from(this.selection.values());
  }

  readonly selection = new Set<string>([]);

  readonly trackByFn: TrackByFunction<ChipSetConfig> = (_, chip) => chip.value;

  onSelect(value: string): void {
    if (this.selection.has(value)) {
      this.selection.delete(value);
    } else {
      this.selection.add(value);
    }
    this.selected.emit(Array.from(this.selection.values()));
  }
}
